module.exports = __webpack_public_path__ + "static/media/11 Minuts 02 June 22 (1).e2dc63bc.pdf";